<template>
    <div class="manifesto">

        <div class="bold manifesto-text" v-html="manifesto.text">
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            manifesto:{

            }
        }
    },
    beforeMount: function(){
        fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/Manifesto?token=a15be93e9cdb43ca2b3778c2077c26')
        .then(data => data.json())
        .then(data => this.manifesto = data);
    },
    mounted: function(){
    var breadcrumbs = [
        {
            text: 'Home',
            link: '/',
            isLink: true
        },
        {
            text: 'Manifesto',
            link: '/manifesto',
            isLink: false
        }
    ];
    this.$emit("updateStatus", breadcrumbs);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Manifesto',
      'page_path': '/manifesto'
    });
  }
}
</script>